'use client'

import { useParams, usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useEventListener, useMediaQuery } from 'usehooks-ts'

import Loading from '@/components/Loading'
import { useUAContext } from '@/context/UAContext'

export default function RouteChangeLoader() {
  const pathname = usePathname()
  const params = useParams()
  const [isRouteLoading, setIsRouteLoading] = useState(false)
  const { deviceType } = useUAContext()
  const isMobileOrTablet = useMediaQuery('(max-width: 1023px)') || deviceType !== 'desktop'

  const [isDragging, setIsDragging] = useState(false)

  useEventListener('click', (e) => {
    if (isDragging) {
      return
    }

    // 🥷🏼 Check if it's a Command + Click (open in new window) or Ctrl + Click
    if (e.metaKey || e.ctrlKey) {
      return
    }

    const target = e.target as HTMLElement
    const link = target.closest('a[href]') as HTMLAnchorElement | null

    if (link?.target === '_blank') {
      return
    }

    if (link && !link.hash && link.hostname === window.location.hostname) {
      if (!isMobileOrTablet) {
        document.body.classList.add('route-loading')
      } else {
        setIsRouteLoading(true)
      }
    }
  })

  useEventListener('dragstart', () => {
    setIsDragging(true)
  })

  useEventListener('dragend', () => {
    setTimeout(() => setIsDragging(false), 100)
  })

  useEventListener('mousedown', (e) => {
    const target = e.target as HTMLElement
    const link = target.closest('a[href]') as HTMLAnchorElement | null

    if (link) {
      link.setAttribute('data-potential-drag', 'true')
    }
  })

  useEventListener('mousemove', (e) => {
    if (e.buttons === 1) {
      const target = e.target as HTMLElement
      const link = target.closest('a[href][data-potential-drag]') as HTMLAnchorElement | null

      if (link) {
        setIsDragging(true)
      }
    }
  })

  useEventListener('mouseup', () => {
    document.querySelectorAll('a[data-potential-drag]').forEach((link) => {
      link.removeAttribute('data-potential-drag')
    })
    setTimeout(() => setIsDragging(false), 100)
  })

  useEffect(() => {
    // 🥷🏼 after changed page, set isAppLoading to false
    document.body.classList.remove('route-loading')
    setIsRouteLoading(false)
  }, [pathname, params])

  if (isMobileOrTablet && isRouteLoading) {
    return <Loading />
  }

  return null
}
